/** True on staging.joinestateflow.com, Vercel previews, and other non-prod deploys. */
function isStaging(): boolean {
  if (process.env.NEXT_PUBLIC_ENV === 'staging') return true;
  if (process.env.VERCEL_ENV === 'preview') return true;
  if (process.env.SITE_URL?.includes('staging')) return true;
  if (process.env.NEXT_PUBLIC_SITE_URL?.includes('staging')) return true;
  if (process.env.NEXT_PUBLIC_APP_URL?.includes('staging')) return true;
  if (typeof window !== 'undefined' && window.location.hostname.includes('staging')) return true;
  return false;
}

export function isPostHogEnabled(): boolean {
  return !isStaging() && Boolean(process.env.NEXT_PUBLIC_POSTHOG_PROJECT_TOKEN);
}
